import cookies from 'browser-cookies';
import { inChinaIcpHost, getCountry } from './pathHelper';

// Set wildcard domain, otherwise cookie cant't be removed.
if (inChinaIcpHost()) {
  cookies.defaults.domain = document.location.hostname.replace(/^snow/, '');
} else {
  cookies.defaults.domain = document.location.hostname.replace(new RegExp(`^${getCountry()}`), '');
}

// Simple way to set cookie with HTML data attributes.
/*
Required
- data-create-cookie="true"
- data-cookie-name="" or href="#nice-named-id"
Optional
- data-cookie-value=""   default: '1'
- data-cookie-expires="" default: '30'
*/

document.addEventListener('turbolinks:load', () => {
  const $ = window.jQuery;
  $(document).on('click', '*[data-create-cookie="true"]', (e) => {
    const $target = $(e.currentTarget);
    const cookieName = $target.attr('data-cookie-name') || $target.attr('href');
    const cookieValue = $target.attr('data-cookie-value') || '1';
    if (!cookieName || !cookieValue) { return; }
    let cookieExpires = Number($target.attr('data-cookie-expires'));
    cookieExpires = Number.isNaN(cookieExpires) ? 30 : cookieExpires;
    cookies.set(cookieName, cookieValue, { expires: cookieExpires });
  });
});

export default cookies;
